$(function () {
	$.ajax({
		type: 'GET',
		url: 'https://graph.facebook.com/v6.0/17841453246334779?fields=name%2Cmedia.limit(4)%7Bcaption%2Clike_count%2Cmedia_url%2Cpermalink%2Ctimestamp%2Cthumbnail_url%2Cmedia_type%2Cusername%7D&access_token=EAANKfVAbl94BANE5p63GVJFhVAfxXv4hhLI8FrUwWkfE4k1mNxTDZCKR5ZBjidpLPgUQKC3mxlTTzsgCguVEZB840TE6i1VHDvjgFiB6oNGUeJgY274LQXvcK5Gh6t24oi6bopKTmETLGoVbLIXtZAZA9sTHfOmcAcLxFhHRQDtm8zODj5EMooQ4f5ZCdA3QxeXCgMcN47JAZDZD',
		dataType: 'json',
		success: function (json) {

			var html = '';
			var insta = json.media.data;
			for (var i = 0; i < insta.length; i++) {
				var media_type = insta[i].media_type;
				if (insta[i].media_type == "IMAGE" || insta[i].media_type == "CAROUSEL_ALBUM") {
					html += '<li><a href="' + insta[i].permalink + '" target="_blank" rel="noopener noreferrer"><span class="square-content"><div class="square-content"><img src="' + insta[i].media_url + '" width="100" height="100" layout="responsive" loading="lazy" alt="Instagram"></div></span></a></li>';
				} else if (media_type == "VIDEO") {
					html += '<li><a href="' + insta[i].permalink + '" target="_blank" rel="noopener noreferrer"><span class="square-content"><div class="square-content"><img src="' + insta[i].thumbnail_url + '" width="100" height="100" layout="responsive" loading="lazy" alt="Instagram"></div></span></a></li>';
					var media_type = '';
				}
			}
			$(".insta_list").append(html);
		},
		error: function () {

			//エラー時の処理
		}
	});
});
